@use '@fukuri-admins/ui/layout' as *;

.Empty {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 912px;
  border: 1px solid border("Tertiary");
  border-radius: borderRadius("lg");

  &__Content {
    text-align: center;

    &__Image {
      width: 160px;
      height: 160px;
      margin-bottom: spacing("24");
    }

    &__Description {
      @include typography("Jp/16_W3");
      color: text("Low");
      margin-bottom: spacing("16");
    }
  }
}
